// 团检用户端的前端会话状态，适用于所有企业，按企业和账号隔离，不保存密码。

const memory: { [key: string]: string } = {};

function keyFor(type: string, appid: string, userId: any): string
{
    return appid && userId ? `employer:${appid}:${userId}:${type}` : "";
}

function read(key: string): string
{
    if (!key) return "";
    try { return sessionStorage.getItem(key) || memory[key] || ""; }
    catch (_) { return memory[key] || ""; }
}

function write(key: string, value: string): void
{
    if (!key) return;
    memory[key] = value;
    try {
        if (value) sessionStorage.setItem(key, value);
        else sessionStorage.removeItem(key);
    } catch (_) { /* 浏览器禁用存储时，至少保留当前页面会话。 */ }
}

export function getReadNotices(appid: string, userId: any): string[]
{
    try {
        const ids = JSON.parse(read(keyFor("readNotices", appid, userId)) || "[]");
        return Array.isArray(ids) ? ids.map(String) : [];
    } catch (_) { return []; }
}

export function markNoticeRead(appid: string, userId: any, noticeId: any): void
{
    const ids = getReadNotices(appid, userId);
    const id = String(noticeId);
    if (ids.indexOf(id) < 0) ids.push(id);
    write(keyFor("readNotices", appid, userId), JSON.stringify(ids));
}

// 仅在登录成功时重置，刷新令牌、修改头像和返回首页均不重置。
export function resetReadNotices(appid: string, userId: any): void
{
    write(keyFor("readNotices", appid, userId), "");
}

export function hasChangedPassword(appid: string, userId: any): boolean
{
    return read(keyFor("passwordChanged", appid, userId)) === "true";
}

export function markPasswordChanged(appid: string, userId: any): void
{
    write(keyFor("passwordChanged", appid, userId), "true");
}

export function savePerfectDraft(appid: string, userId: any, data: any): void
{
    write(keyFor("perfectDraft", appid, userId), JSON.stringify(data));
}

export function getPerfectDraft(appid: string, userId: any): any
{
    try { return JSON.parse(read(keyFor("perfectDraft", appid, userId)) || "null"); }
    catch (_) { return null; }
}

export function clearPerfectDraft(appid: string, userId: any): void
{
    write(keyFor("perfectDraft", appid, userId), "");
}
